import React from 'react';
import PropTypes from 'prop-types';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import TranslationTable from 'shared/components/translationTable/TranslationTableConnector';
import CloseDialog from 's1-ui/sovos-sliding-panel/components/closeDialog/CloseDialog';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  UPDATE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';
import LinearProgress from 'material-ui/LinearProgress';

class TranslationTableMenu extends React.Component {

  state = {
    openTranslationPanel: false,
    cancelTTDialogOpen: false,
    saveButtonEnable: true,
    openConfirmDeleteDialog: false
  }; 

  componentDidMount() {
    if(this.props.profileEditionMode === UPDATE) {
      this.props.profileTTActions.fetchTranslationTables(this.props.mapId);      
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.isSavingTranslationTable && !nextProps.isSavingTranslationTable) {
      this.handleCloseTranslationPanel();
    }
  }

  handleOpenTranslationPanel = () => { this.setState({ openTranslationPanel: true }); };

  handleCloseTranslationPanel = () => this.setState({ openTranslationPanel: false });

  handleCreateTableClick = () => {
    this.props.ttActions.resetTranslationTableEditionMode();
    this.handleOpenTranslationPanel();
  };
  
  handleEditTableClick = tTableId => {
    this.props.ttActions.setTranslationTableEditionMode();
    this.props.ttActions.fetchTranslationTable(tTableId);
    this.handleOpenTranslationPanel();
  };

  handleTTSaveClick = () => {
    this.setState({ saveButtonEnable: false });
    this.props.ttActions.saveTranslationTable(this.props.translationTable);
  };

  handleConfirmDialog = () => {
    if (this.props.translationTableFromCreate && !this.props.translationTableEditionMode) {
      this.props.ttActions.deleteTranslationTable(this.props.translationTable.id);
    }
    if (this.props.translationTable.id) {
      this.props.ttActions.cancelTranslationTable(this.props.translationTable.id);
    }
    this.setState({ cancelTTDialogOpen: false });
    this.handleCloseTranslationPanel();
  };

  handleDeleteTranslationTable = () => {
    this.props.profileTTActions.deleteUnconfirmedTranslationTableFromList(this.props.translationTable.id);
    this.props.ttActions.deleteTranslationTable(this.props.translationTable.id);  
    this.setDeleteButtonFlag(false);  
    this.handleCloseTranslationPanel(); 
  };

  setDeleteButtonFlag = value => {
    this.setState({ openConfirmDeleteDialog: value });
  };

  isSaveButtonEnable = isTTWithValues => this.setState({ saveButtonEnable: isTTWithValues });

  render() {
    const {
      currentDivision,
      showColumnLists,
      translationTable,
      translationTables,
      fetchingTranslationTables,
      unconfirmedTranslationTables,
      translationTableEditionMode,
      fetchingAllTranslationTables
    } = this.props;

    return (
      <div className="map-columns__subgroup-section">
        <h4>2. Create Translation Tables <span className="map-columns__header_grayed">(Optional)</span></h4>
        <p>Map Input Data values in the Sovos system. For example: map SKUs to Sovos Goods/Service codes.</p>
        <div className="translation-tables-menu">
          {
            (fetchingTranslationTables || fetchingAllTranslationTables) &&
            <LinearProgress mode="indeterminate" style={ { marginTop: 8, marginBottom: 8 } } />
          }
          { 
            !fetchingTranslationTables && !fetchingAllTranslationTables &&
            <ul className="translation-tables-menu__list">
              {
                translationTables.map( ttable => (<li key={ ttable.id } onClick={ () => this.handleEditTableClick(ttable.id) }>{ttable.name}</li>))
              }
              { 
                unconfirmedTranslationTables.map( ttable => (<li key={ ttable.id } onClick={ () => this.handleEditTableClick(ttable.id) }>{ttable.name}</li>))
              }
            </ul>
          }
        </div>
        <SovosButtonsGroup align="right">
          <SovosRaisedButton color="secondary" onClick={ this.handleCreateTableClick } disabled={ !currentDivision || !showColumnLists } >CREATE TABLE</SovosRaisedButton>
        </SovosButtonsGroup>
        <SovosEditableSlidingPanel
          isDirty={ () => true }
          contentStyle={ { padding: 0 } }
          open={ this.state.openTranslationPanel }
          onClose={ this.handleConfirmDialog }
          baseWidth={ '1080px' }
          title={ `${translationTableEditionMode ? 'Update' : 'Create'} Translation Table` }
          SaveButtonProps={
            {
              disabled: !this.state.saveButtonEnable,
              onClick: this.handleTTSaveClick,
              className: 'map-columns__button'
            }
          }
          CancelButtonProps={
            {
              className: 'map-columns__button',
              children: 'CANCEL'
            }
          }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
          additionalButtons={ [
            <SovosRaisedButton className={ 'map-columns__button' } color="secondary" disabled={ !translationTableEditionMode } onClick={ () => this.setDeleteButtonFlag(true) } key={ 'delete-tt' } >DELETE</SovosRaisedButton>,
            <SovosRaisedButton className={ 'map-columns__button' } color="secondary" disabled key={ 'import-tt' } >IMPORT</SovosRaisedButton>,
            <SovosRaisedButton className={ 'map-columns__button' } color="secondary" disabled key={ 'export-tt' } >EXPORT</SovosRaisedButton>                  
          ] }
        >
          <TranslationTable isSaveButtonEnable = { isTTWithValues => this.isSaveButtonEnable(isTTWithValues) }/>
        </SovosEditableSlidingPanel>
        <CloseDialog        
          open = { this.state.openConfirmDeleteDialog }
          DialogTitleProps=  { {
            children : 'Delete \''+ translationTable.name +'\'?',
            className : ''
          } }
          DialogContentProps = { {
            className: '',
            children: 'Are you sure you want to delete this translation table?'
          } }
          OKButtonProps =  { {
            children : 'YES' ,
            onClick : this.handleDeleteTranslationTable
          } }
          CancelButtonProps = { {
            children : 'NO' ,
            onClick : () => this.setDeleteButtonFlag(false) 
          } }          
        />
      </div>
    );
  }
}

TranslationTableMenu.propTypes = {
  currentDivision: PropTypes.string,
  showColumnLists: PropTypes.bool.isRequired,
  translationTable: PropTypes.object.isRequired,
  fetchingAllTranslationTables: PropTypes.bool,
  translationTables: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    draft: PropTypes.bool
  })).isRequired,
  unconfirmedTranslationTables: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    draft: PropTypes.bool
  })).isRequired,
  translationTableFromCreate: PropTypes.bool.isRequired,
  isSavingTranslationTable: PropTypes.bool.isRequired,
  ttActions: PropTypes.shape({
    createTranslationTable: PropTypes.func,
    saveTranslationTable: PropTypes.func,
    deleteTranslationTable: PropTypes.func,
    cancelTranslationTable: PropTypes.func,
    fetchTranslationTable: PropTypes.func,
    setTranslationTableEditionMode: PropTypes.func,
    resetTranslationTableEditionMode: PropTypes.func
  }).isRequired,
  profileTTActions: PropTypes.shape({
    fetchTranslationTables: PropTypes.func,
    deleteUnconfirmedTranslationTableFromList: PropTypes.func
  }).isRequired,
  mapId: PropTypes.number,
  fetchingTranslationTables: PropTypes.bool,
  profileEditionMode: PropTypes.string.isRequired,
  translationTableEditionMode: PropTypes.bool
};

export default TranslationTableMenu;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/translationTableMenu/TranslationTableMenu.js